var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoiMarkerFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.1,
    d: "M11 30.5C13.4853 30.5 15.5 29.8284 15.5 29C15.5 28.1716 13.4853 27.5 11 27.5C8.51472 27.5 6.5 28.1716 6.5 29C6.5 29.8284 8.51472 30.5 11 30.5Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.05,
    d: "M11 27.5C13.49 27.5 15.5 28.17 15.5 29C15.5 29.83 13.5 30.5 11 30.5C8.5 30.5 6.5 29.83 6.5 29C6.5 28.17 8.5 27.5 11 27.5ZM11 26C8.1 26 5 26.79 5 29C5 31.21 8.1 32 11 32C13.9 32 17 31.21 17 29C17 26.79 13.9 26 11 26Z",
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.29 28.58C9.1266 26.1244 7.58444 23.8668 5.71998 21.89C2.99998 18.68 0.419983 15.64 0.419983 11C0.419983 8.19405 1.53466 5.50299 3.51879 3.51885C5.50293 1.53472 8.19399 0.420044 11 0.420044C13.806 0.420044 16.497 1.53472 18.4812 3.51885C20.4653 5.50299 21.58 8.19405 21.58 11C21.58 15.64 19 18.68 16.28 21.89C14.4155 23.8668 12.8734 26.1244 11.71 28.58H10.29Z",
    fill: "#FAA19C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11 0.85C13.6911 0.852647 16.2713 1.92287 18.1742 3.82579C20.0771 5.72871 21.1474 8.30886 21.15 11C21.15 15.49 18.63 18.46 15.96 21.61C14.1364 23.5552 12.6099 25.7589 11.43 28.15H10.57C9.3778 25.7564 7.83777 23.5525 6 21.61C3.37 18.46 0.85 15.49 0.85 11C0.852647 8.30886 1.92287 5.72871 3.82579 3.82579C5.72871 1.92287 8.30886 0.852647 11 0.85ZM11 0C8.08262 0 5.28473 1.15893 3.22183 3.22183C1.15893 5.28473 0 8.08262 0 11C0 19 7.5 22.5 10 29H12C14.5 22.5 22 19 22 11C22 8.08262 20.8411 5.28473 18.7782 3.22183C16.7153 1.15893 13.9174 0 11 0V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiMarkerFloor);
export default __webpack_public_path__ + "static/media/poi_marker_floor.c5f615bc42b81aadb272bd2fd96d29e6.svg";
export { ForwardRef as ReactComponent };